<template>
  <div class="k8m-tags-badge-container">
    <span class="k8m-tags-badge-label">
      {{ label }}
    </span>
    <span class="k8m-tags-badge-value">
      {{ value }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.k8m-tags-badge-container {
  display: inline-flex;
  align-items: center;
  border: 2px solid $color-brand-accent;
  border-radius: 5px;
  font-size: 1.2rem;
}

.k8m-tags-badge-label {
  background-color: $color-brand-accent;
  color: $font-contrast;
  padding: 2px 8px;
  border-radius: 0;
  white-space: nowrap;
  font-weight: 600;
}
.k8m-tags-badge-value {
  background-color: transparent;
  color: $color-brand-accent;
  padding: 2px 8px;
  border-radius: 0;
  white-space: nowrap;
  font-weight: 600;
}
</style>
